import { BookDateCode, BookIntervalCode, BookTimeCode } from "@/types";
import { IBookInterval } from "./lineInfo.types";

export class BookInterval implements IBookInterval {
  readonly bookIntervalCode: BookIntervalCode; // BDT-MONTH
  readonly bookIntervalName: string;
  readonly seatsSelectable?: boolean;
  readonly lineTurnUid?: string; // 202106240527011411553019998LNT",
  readonly lineRouteNo?: string; // 당산B",
  readonly lineRouteName?: string; // 당산B",
  readonly lineTypeCode?: string; // LRT-BACKWA",
  readonly bookPointCode?: string; // BKP-NORMAL",
  readonly displayOrder?: number; //  0
  readonly bookBeginDateCode: BookDateCode; // BDC-DAY",
  readonly bookBeginYear: number; //  0,
  readonly bookBeginMonth: number; //  -1,
  readonly bookBeginWeek?: number; // -1
  readonly bookBeginWeekdayCode?: string; // WKD-FRI
  readonly bookBeginWeekdayName?: string; // 금요일
  readonly bookBeginDay: number; //  17,
  readonly bookBeginTimeCode: BookTimeCode; // BTC-FIXED",
  readonly bookBeginHour: number; //  10,
  readonly bookBeginMin: number; //  0,
  readonly bookEndDateCode: BookDateCode; // BDC-BEGIN",
  readonly bookEndYear: number; //  0,
  readonly bookEndMonth: number; //  0,
  readonly bookEndDay: number; //  0,
  readonly bookEndTimeCode: BookTimeCode; // BTC-BEGIN",
  readonly bookEndHour: number; //  0,
  readonly bookEndMin: number; //  -10,
  readonly bookCancelDateCode: BookDateCode; // BDC-BEGIN",
  readonly bookCancelYear: number; //  0,
  readonly bookCancelMonth: number; //  0,
  readonly bookCancelDay: number; //  0,
  readonly bookCancelTimeCode: BookTimeCode; // BTC-FIXED",
  readonly bookCancelHour: number; //  5,
  readonly bookCancelMin: number; //  0,

  constructor(data: IBookInterval) {
    this.bookIntervalCode = data.bookIntervalCode;
    this.bookIntervalName = data.bookIntervalName;
    this.seatsSelectable = data.seatsSelectable;
    this.lineTurnUid = data.lineTurnUid;
    this.lineRouteNo = data.lineRouteNo;
    this.lineRouteName = data.lineRouteName;
    this.lineTypeCode = data.lineTypeCode;
    this.bookPointCode = data.bookPointCode;
    this.displayOrder = data.displayOrder;
    this.bookBeginDateCode = data.bookBeginDateCode;
    this.bookBeginYear = data.bookBeginYear;
    this.bookBeginMonth = data.bookBeginMonth;
    this.bookBeginWeek = data.bookBeginWeek;
    this.bookBeginWeekdayCode = data.bookBeginWeekdayCode;
    this.bookBeginWeekdayName = data.bookBeginWeekdayName;
    this.bookBeginDay = data.bookBeginDay;
    this.bookBeginTimeCode = data.bookBeginTimeCode;
    this.bookBeginHour = data.bookBeginHour;
    this.bookBeginMin = data.bookBeginMin;
    this.bookEndDateCode = data.bookEndDateCode;
    this.bookEndYear = data.bookEndYear;
    this.bookEndMonth = data.bookEndMonth;
    this.bookEndDay = data.bookEndDay;
    this.bookEndTimeCode = data.bookEndTimeCode;
    this.bookEndHour = data.bookEndHour;
    this.bookEndMin = data.bookEndMin;
    this.bookCancelDateCode = data.bookCancelDateCode;
    this.bookCancelYear = data.bookCancelYear;
    this.bookCancelMonth = data.bookCancelMonth;
    this.bookCancelDay = data.bookCancelDay;
    this.bookCancelTimeCode = data.bookCancelTimeCode;
    this.bookCancelHour = data.bookCancelHour;
    this.bookCancelMin = data.bookCancelMin;
  }
}
